import type { ImgHTMLAttributes, ReactNode } from "react";
import { ImageSizes } from "~enums/imageSizes.ts";
import type { ImageTypes } from "~enums/imageTypes";

type Props = ImgHTMLAttributes<HTMLImageElement> & {
  imageUrl?: string;
  imageType: ImageTypes;
  fallback?: ReactNode;
  size?: ImageSizes;
};

const ImageView = ({ imageUrl, imageType, size, width, height, fallback, ...imageProps }: Props) => {
  if (imageUrl) {
    return <img {...imageProps} loading={"lazy"} alt={imageType} src={`${imageUrl}${size ? `?size=${size}` : ""}`} width={width} height={height} />;
  }
  if (fallback) {
    return fallback;
  }
  return <i style={{ width }} className="fas fa-shield fa-xl" />;
};

export default ImageView;
